(function() {
  var Controller,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.CustomersController = (function(superClass) {
    extend(CustomersController, superClass);

    function CustomersController(scope, transitions, state, service, filterService, loading, ngModal) {
      var unregisterPdfProcessingHandler;
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.service = service;
      this.filterService = filterService;
      this.loading = loading;
      this.ngModal = ngModal;
      CustomersController.__super__.constructor.apply(this, arguments);
      this.scope.title = 'Customers';
      this.scope.fullpage = true;
      this.scope.alwaysReenable = true;
      this.scope.$on('Customers:run', (function(_this) {
        return function(_, filters) {
          _this.filters = filters;
          return _this.refresh(filters);
        };
      })(this));
      this.scope.resize = 0;
      this.scope.$emit('Customers:init');
      unregisterPdfProcessingHandler = Socket.register('pdfProcessingUpdate', (function(_this) {
        return function(data) {
          var program;
          if (_this.filters.years[0].key === !data.year) {
            return;
          }
          if (data.customer_id) {
            return;
          }
          program = _this.programs.find(function(p) {
            return p.program_id === data.program_id && p.crop_id === data.crop_id;
          });
          if (!program) {
            return;
          }
          return program.processing = data.processing;
        };
      })(this));
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          return unregisterPdfProcessingHandler();
        };
      })(this));
    }

    CustomersController.prototype.generatePDF = function(program) {
      var url;
      if (program == null) {
        return;
      }
      url = '/backend/portal/sustainability-programs/gen-program-pdf';
      this.service.generatePDF(url, program.year, program.crop_id, program.program_id);
      return this.ngModal.launchReportGeneratingDialog();
    };

    CustomersController.prototype.launchModal = function(program) {
      return this.ngModal.launchSusCustomersDialog(program, this.susCustomers);
    };

    CustomersController.prototype.refresh = function(filters) {
      this.service.getSusCustomers().then((function(_this) {
        return function(response) {
          return _this.susCustomers = response;
        };
      })(this));
      return this.service.getPrograms(filters).then((function(_this) {
        return function(response) {
          _this.programs = response.programs;
          return _this.scope.resize += 1;
        };
      })(this));
    };

    return CustomersController;

  })(Controller);

}).call(this);
